module.exports = __webpack_public_path__ + "img/161.c108d95e.jpg";